import {removeRedundantWhiteSpaces} from "@pg-mono/string-utils";

import {BRAND_NAME} from "../../app/constants/company";
import {getPromotionListingHeading} from "../../promotion/helpers/promotion_listing_config";
import {PromotionType} from "../../promotion/helpers/PromotionType";

export interface ITitlePromotionList {
    date?: Date;
    region?: string;
    page?: number;
    type?: PromotionType;
}

export const titlePromotionList = (props: ITitlePromotionList) => {
    const page = typeof props.page === "number" && props.page > 1 ? ` - Strona ${props.page}` : "";
    const heading = getPromotionListingHeading({type: props.type, regionName: props.region, date: props.date});

    return removeRedundantWhiteSpaces(`${heading}${page} - ${BRAND_NAME}`);
};
import {removeRedundantWhiteSpaces} from "@pg-mono/string-utils";

import {BRAND_NAME} from "../../app/constants/company";
import {getPromotionListingHeading} from "../../promotion/helpers/promotion_listing_config";
import {PromotionType} from "../../promotion/helpers/PromotionType";

export interface ITitlePromotionList {
    date?: Date;
    region?: string;
    page?: number;
    type?: PromotionType;
}

export const titlePromotionList = (props: ITitlePromotionList) => {
    const page = typeof props.page === "number" && props.page > 1 ? ` - Strona ${props.page}` : "";
    const heading = getPromotionListingHeading({type: props.type, regionName: props.region, date: props.date});

    return removeRedundantWhiteSpaces(`${heading}${page} - ${BRAND_NAME}`);
};
